import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJAIAudioHistory from '../view/FJAIAudioHistory.jsx';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import FJSelectAll from '../../../../common/components/FJSelectAll/FJSelectAll.jsx';
import { setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import { useEffect, useCallback } from 'react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';

const FJAIAudioHistoryContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);
    const isMultipleMode = useSelector(state => state.AIAudioGenerator.isMultipleMode);
    const appType = useSelector(state => state.common.appType);
    const setIsMultipleMode = bool => {
        dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(bool));
        FJAudioPlayManager.pauseAll();
    };

    const clearSelected = () => {
        setIsMultipleMode(false);
    };

    const setSliceSelectList = value => {
        dispatch(setSliceSelectListAction(value));
    };

    const multiDownload = (ids, source, callback) => {
        dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
    };
    const multiDelete = ids => {
        dispatch(FJActionCommon.multiDeleteAction(ids));
    };

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                setSliceSelectList([]);
                setIsMultipleMode(false);
            }
        },
        [setSliceSelectList],
    );
    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
        //TODO 业务需要此依赖
    }, [_keyDown, isMultipleMode]);

    const _onAddToMediaLibrary = () => {
        const ids = historyList.filter(item => selectList.includes(item.id)).map(item => item.id);
        dispatch(FJActionAIAudioGenerator.addToMediaLibraryAction(ids));
    };

    return (
        <>
            <FJAIAudioHistory
                historyList={historyList}
                setIsMultipleMode={setIsMultipleMode}
                isMultipleMode={isMultipleMode}
                setSliceSelectList={setSliceSelectList}
            />
            <FJSelectAll
                appType={appType}
                list={historyList}
                selectList={selectList}
                setSelectList={setSliceSelectList}
                multiDownload={multiDownload}
                multiDelete={multiDelete}
                batchDownloadLoading={batchDownloadLoading}
                isMultipleMode={isMultipleMode}
                clearSelected={clearSelected}
                isShowAddToMediaButton={window.isEditPage}
                onAddToMediaLibrary={_onAddToMediaLibrary}
            />
        </>
    );
};
export default FJAIAudioHistoryContainer;
